var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import { ConfigureConsts } from '../../../../../shared/configure-consts';
import { ZoomHelper } from '../../shared/zoom-helper';
import { ZoomOperation } from '../../shared/zoom-operation';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var ZoomSettingsComponent = /** @class */ (function (_super) {
    __extends(ZoomSettingsComponent, _super);
    function ZoomSettingsComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.zoomTypes = ZoomHelper.zoomTypes;
        _this.zoom = ZoomHelper.defaultZoom;
        _this.maxScale = ZoomHelper.defaultMaxScale;
        _this.minScale = ZoomHelper.defaultMinScale;
        _this.increaseMouseOvered = false;
        _this.increaseMouseDowned = false;
        _this.decreaseMouseOvered = false;
        _this.decreaseMouseDowned = false;
        return _this;
    }
    ZoomSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentDiagramZoomChangeCallback = function (value) {
            if (_this.zoom !== value) {
                _this.zoom = value;
            }
        };
        abp.event.on(ConfigureConsts.event.zoomChangedEventName, this.currentDiagramZoomChangeCallback);
    };
    ZoomSettingsComponent.prototype.ngOnDestroy = function () {
        abp.event.off(ConfigureConsts.event.zoomChangedEventName, this.currentDiagramZoomChangeCallback);
    };
    ZoomSettingsComponent.prototype.changeZoom = function (zoom) {
        if (this.commandHandler) {
            this.commandHandler.changeZoom(zoom);
            this.commandHandler.diagram.focus();
        }
    };
    ZoomSettingsComponent.prototype.changeZoomType = function (zoom) {
        this.changeZoom(Number(zoom));
    };
    ZoomSettingsComponent.prototype.increaseZoom = function () {
        this.operationZoom(ZoomOperation.Increase);
        if (this.commandHandler) {
            this.commandHandler.diagram.focus();
        }
    };
    ZoomSettingsComponent.prototype.decreaseZoom = function () {
        this.operationZoom(ZoomOperation.Decrease);
        if (this.commandHandler) {
            this.commandHandler.diagram.focus();
        }
    };
    ZoomSettingsComponent.prototype.operationZoom = function (operation) {
        var newZoom = ZoomHelper.getZoom(Number(this.zoom), operation);
        if (newZoom !== this.zoom) {
            this.changeZoom(newZoom);
            this.zoom = newZoom;
        }
    };
    __decorate([
        Input()
    ], ZoomSettingsComponent.prototype, "commandHandler", void 0);
    ZoomSettingsComponent = __decorate([
        Component({
            selector: 'zoom-settings',
            template: "<span class='design-span-zoom'> <a (click)=\"increaseZoom()\" tooltip=\"{{lc('IncreaseZoom')}}\" class=\"increase-zoom\"> <i *ngIf=\"zoom!=maxScale\" class=\"fcloud-increase-zoom\"></i> <i *ngIf=\"zoom==maxScale\" [ngClass]=\"{'fcloud-increase-zoom-disable':zoom==maxScale}\"></i> </a> <select name=\"zoom\" [(ngModel)]=\"zoom\" class=\"zoom-type\" (change)=\"changeZoomType(zoom)\"> <option *ngFor=\"let zoom of zoomTypes\" [value]=\"zoom.key\">{{zoom.name}}</option> </select> <a (click)=\"decreaseZoom()\" tooltip=\"{{lc('DecreaseZoom')}}\" class=\"decrease-zoom\"> <i *ngIf=\"zoom!=minScale\" class=\"fcloud-decrease-zoom\"></i> <i *ngIf=\"zoom==minScale\" [ngClass]=\"{'fcloud-decrease-zoom-disable':zoom==minScale}\"></i> </a> </span>",
            styles: [".design-span-zoom { display: inline-block; a { width: 18px; height: 20px; display: inline-block; font-size: 21px; cursor: pointer; vertical-align: sub; margin-left: 5px; margin-right: 4px; } .zoom-type { position: relative; top: -4px; margin-left: 3px; padding-left: 2px; width: 52px; height: 18px; line-height: 17px; font-size: 12px; color: #666; } select { border: solid 1px #7f939f; -moz-appearance: none; -webkit-appearance: none; background: url(\"/assets/common/images/configure/arrow.png\") no-repeat scroll right center transparent; padding-right: 14px; vertical-align: sub; } .increase-zoom, .decrease-zoom{ background-image: none !important; } .increase-zoom:hover .fcloud-increase-zoom:before{ content: \"\\e93c\"; } .decrease-zoom:hover .fcloud-decrease-zoom:before{ content: \"\\e940\"; } .increase-zoom:active .fcloud-increase-zoom:before{ content: \"\\e939\"!important; color: #3695ff!important; } .decrease-zoom:active .fcloud-decrease-zoom:before{ content: \"\\e93e\"!important; color: #3695ff!important; } } "],
        })
    ], ZoomSettingsComponent);
    return ZoomSettingsComponent;
}(ConfigureComponentBase));
export { ZoomSettingsComponent };
